module.exports = __webpack_public_path__ + "img/image-thumb-22.b34ec5d6.jpg";